import apiClient from '@u/apiClient'
import FetchFamilySpaceDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchFamilySpaceDossierByIdController'
import UpdateFamilySpaceDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateFamilySpaceDossierByIdController'

export default {
  fetchFamilySpaceData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchFamilySpaceDossierByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateFamilySpaceData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateFamilySpaceDossierByIdController.put({
            dossier: payload.dossier_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
